var quizQuestions = [
  {
    question: "Pedestrians at a crosswalk always have the right-of-way.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Pedestrians in marked or unmarked crosswalks always have the right-of-way. Drivers must stop and yield to pedestrians at crosswalks, regardless of traffic signals or signs.",
    correctAnswer: "a"
  },
  {
    question: "It is permitted to use advanced technologies like self-parking and back-up cameras on a driving test.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Typically, advanced driving aids such as self-parking systems and backup cameras are not permitted during official driving tests. Drivers must demonstrate their ability to park and maneuver the vehicle independently without assistance from automated technology.",
    correctAnswer: "b"
  },
  {
    question: "How many times more likely are you to survive a fatal crash by wearing a seat belt?",
    answers: {
      a: "1.5 times",
      b: "2 times",
      c: "3 to 4 times",
      d: "10 times"
    },
    description: "Wearing a seat belt significantly increases your chance of surviving a serious crash. Studies show that occupants wearing seat belts are approximately 3 to 4 times more likely to survive a fatal crash compared to those not buckled up.",
    correctAnswer: "c"
  },
  {
    question: "How many points do you receive for your first DWAI conviction?",
    answers: {
      a: "2 points",
      b: "4 points",
      c: "6 points",
      d: "8 points"
    },
    description: "Even if it is your first conviction, you can receive <strong>8 points</strong> on your driver's license. Should you be convicted a second time, your license will be suspended for a year.",
    correctAnswer: "d"
  },
  {
    question: "What is the maximum fine for your first DUI conviction?",
    answers: {
      a: "$500",
      b: "$750",
      c: "$1,000",
      d: "$1,250"
    },
    description: "If you are convicted of a DUI, you can receive a fine up to <strong>$1,000</strong>. This fine does not include administrative fees or any additional fees, like enrollment in a substance abuse program.",
    correctAnswer: "c"
  },
  {
    question: "How much time could you spend in jail for a third or subsequent DWAI or DUI?",
    answers: {
      a: "2 to 180 days",
      b: "5 days to 1 year",
      c: "10 days to 1 year",
      d: "60 days to 1 year"
    },
    description: "Should you be charged with a DWAI or DUI for a third time you will spend at least <strong>60 days and up to 1 year</strong> in jail.",
    correctAnswer: "d"
  },
  {
    question: "What is the legal BAC limit for minors?",
    answers: {
      a: ".00 BAC",
      b: ".01 BAC",
      c: ".02 BAC",
      d: ".03 BAC"
    },
    description: "Under Colorado's Zero Tolerance Policy, minors can be charged with a DWAI or DUI for having a BAC of just <strong>.02%</strong>.",
    correctAnswer: "c"
  },
  {
    question: "Your hands should be placed at the 10 o'clock and two o'clock positions on a steering wheel.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "While two and 10 o'clock used to be considered safe, recent studies indicate it might be dangerous if the vehicle has an air bag. Now the three and nine o'clock positions are recommended.",
    correctAnswer: "b"
  },
  {
    question: "When backing up your car, you should always look over your left shoulder.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Always look over your <strong>right shoulder</strong> when backing up a car.",
    correctAnswer: "b"
  },
  {
    question: "If an arrow light is flashing yellow, you must come to a complete stop and wait for it to turn green before turning.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "A flashing yellow arrow light means you must yield to oncoming traffic, but, if it is safe to do so, you may turn. If the arrow light is a steady yellow, the light is about to turn red. If the arrow light is red, you are not allowed to turn.",
    correctAnswer: "b"
  },
  {
    question: "A diamond-shaped sign conveys what kind of information to drivers?",
    answers: {
      a: "It signals a no passing zone",
      b: "It tells drivers they're in a school zone",
      c: "It warns drivers of hazards ahead",
      d: "It informs drivers of regulatory information"
    },
    description: "Diamond-shaped signs will <strong>warn drivers of existing or possible hazards ahead on the road</strong>. Pennant signs warn of no passing zones. Pentagon signs tell drivers about school zones. Vertical-rectangle signs provide regulatory information.",
    correctAnswer: "c"
  },
  {
    question: "What does this sign mean?<br /><img src=\"/images/quiz/quiz9.jpg\" alt=\"Road Sign\" />",
    answers: {
      a: "Sharp turn ahead",
      b: "Slippery when wet",
      c: "Road curve ahead",
      d: "Proceed with caution"
    },
    description: "This sign serves to tell drivers that during certain weather conditions, this road will become more precarious.",
    correctAnswer: "b"
  },
  {
    question: "When a road sign is green, it generally provides the driver with what information?",
    answers: {
      a: "A regulation",
      b: "Direction guidance",
      c: "A general warning",
      d: "Scenic guidance"
    },
    description: "Green signs usually <strong>indicate permitted movements and directional guidance</strong>. Brown signs, on the other hand, give motorists public recreation information and scenic guidance.",
    correctAnswer: "b"
  },
  {
    question: "White, broken lines on the highway separates traffic lanes moving in the same direction.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "A dotted white line <strong>divides traffic lanes that are moving in the same direction</strong>. You are free to switch lanes when the road is clear. A dotted yellow line means you are on a single lane road, but you are allowed to pass.",
    correctAnswer: "a"
  },
  {
    question: "You must drive in a clockwise direction in a roundabout.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "Roundabouts always travel in a <strong>counter-clockwise</strong> direction.",
    correctAnswer: "b"
  },
  {
    question: "At an intersection, you must yield the right-of-way to the driver on your left.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "<strong>The driver to the right always has the right-of-way</strong>. However, always make sure the drivers around you are stopping before assuming they've yielded the right-of-way to you.",
    correctAnswer: "b"
  },
  {
    question: "If two cars face each other on a mountain road where only one car can get through, the car facing uphill has the right-of-way.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "If two cars are trying to slip through the same spot on a mountain road, the car going downhill has more control and must therefore back up until the car going uphill can pass.",
    correctAnswer: "a"
  },
  {
    question: "If a school bus is stopped with its red lights flashing, how far away from it must you stop?",
    answers: {
      a: "10 feet",
      b: "15 feet",
      c: "20 feet",
      d: "25 feet"
    },
    description: "If you are approaching a school bus that is loading or unloading children, you must stop <strong>20 feet</strong> away from the bus on either side of the road.",
    correctAnswer: "c"
  },
  {
    question: "Unless otherwise posted, the speed limit in a residential area is:",
    answers: {
      a: "15 mph",
      b: "20 mph",
      c: "25 mph",
      d: "30 mph"
    },
    description: "While local governments have the right to change speed limits, Colorado has a set speed limit of <strong>30 mph</strong> on residential roads unless there is another posted speed limit.",
    correctAnswer: "d"
  },
  {
    question: "It is illegal to park within 15 feet of a fire hydrant.",
    answers: {
      a: "True",
      b: "False"
    },
    description: "There are several places where it is always illegal to stop in Colorado, and some of those include within 15 feet of a fire hydrant, or within 30 feet of a traffic signal, stop sign or railroad.",
    correctAnswer: "a"
  }
];
